import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MenuComponent } from '../../layout/menu/menu.component';
import { CarrosselComponent } from '../../layout/carrossel/carrossel.component';
import { ServicosComponent } from '../../layout/servicos/servicos.component';
import { ContactoComponent } from '../../layout/contacto/contacto.component';
import { RodapeComponent } from "../../layout/rodape/rodape.component";

@Component({
  selector: 'app-inicio',
  imports: [
    MenuComponent,
    CarrosselComponent,
    ServicosComponent,
    ContactoComponent,
    RodapeComponent
],
  templateUrl: './inicio.component.html',
  styleUrl: './inicio.component.css'
})
export class InicioComponent implements OnInit {
  constructor(private title: Title, private meta: Meta) {}

  ngOnInit() {
    this.title.setTitle('Fluxodigital - Web | Infra');
    this.meta.updateTag({ 
      name: 'description', 
      content: 'Desenvolvimento, Operações e Infraestruturas de TI' 
    });

    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Fluxodigital - Web | Infra' });
    this.meta.updateTag({ property: 'og:description', content: 'Desenvolvimento, Operações e Infraestruturas de TI' });
    this.meta.updateTag({ property: 'og:image', content: 'https://fluxo-digital.com/img/FluxoBanner.png' });
  }
}
